// Brand badges — react-icons/si does not carry Salesforce/AWS/Mulesoft/IBM
// (trademark policy). Per design guidelines, we render highly styled
// typography badges instead.

export function BrandBadge({ vendor, size = 40 }) {
  const styles = {
    Salesforce: { bg: "#00A1E0", text: "#FFFFFF", label: "sf", full: "salesforce" },
    AWS: { bg: "#232F3E", text: "#FF9900", label: "aws", full: "amazon web services" },
    Mulesoft: { bg: "#00A0DF", text: "#FFFFFF", label: "M.", full: "mulesoft" },
    IBM: { bg: "#0F62FE", text: "#FFFFFF", label: "IBM", full: "ibm" },
    PMP: { bg: "#0A0A0A", text: "#FFFFFF", label: "PMP", full: "project management" },
    ITIL: { bg: "#0A0A0A", text: "#FACC15", label: "ITIL", full: "itil v4" },
  };
  const s = styles[vendor] || { bg: "#0A0A0A", text: "#FFFFFF", label: vendor.slice(0, 3), full: vendor };
  return (
    <div
      className="grid place-items-center font-display font-bold shrink-0"
      style={{
        width: size,
        height: size,
        background: s.bg,
        color: s.text,
        fontSize: Math.max(11, Math.round(size * 0.32)),
        letterSpacing: "-0.02em",
      }}
      aria-label={s.full}
    >
      {s.label}
    </div>
  );
}

export const VENDOR_COLORS = {
  Salesforce: "#00A1E0",
  AWS: "#FF9900",
  Mulesoft: "#00A0DF",
  IBM: "#0F62FE",
};
